import React, { createContext, useContext } from "react";

const PagePropsContext = createContext({});

export const PagePropsProvider = ({
  // Landing
  localeLanding,

  book,
  booksSet,

  isLanding,
  isSetLanding,
  isSetRPRAC,
  isSetCONFLICT,
  isSetTESTIMONIES,
  isBigLanding,
  landingConfigBooksSet,
  landingIdBooksSet,
  bookTitles,
  bookSites,
  bookCategory,
  landingBookId,
  landingBookViewConfig,
  // ===================

  // Rest
  pageUrl,
  urlOrigin,

  children,
}) => {
  return (
    <PagePropsContext.Provider
      value={{
        // Landing
        localeLanding,

        isLanding,
        isSetLanding,
        isSetRPRAC,
        isSetCONFLICT,
        isSetTESTIMONIES,
        isBigLanding,

        bookTitles,
        bookSites,
        bookCategory,

        landingBookId,
        book,
        landingBookViewConfig,

        booksSet,
        landingConfigBooksSet,
        landingIdBooksSet,
        // ===================

        // Rest
        pageUrl,
        urlOrigin,
      }}>
      {children}
    </PagePropsContext.Provider>
  );
};

/**
 * @returns {{
 *    localeLanding: string,
 * 
 *    isLanding: boolean,
 *    isSetLanding: boolean,
 *    isSetRPRAC: boolean,
 *    isBigLanding: boolean,
 *
 *    bookTitles: []|null,
 *    bookSites: []|null,
 *
 *    landingBookId: string,
 *    book: {}|null,
 *    landingBookViewConfig: {},
 *
 *    booksSet: {}|null,
 *    landingConfigBooksSet: {}|null,
 *
 *    pageUrl: string,
 *    urlOrigin: string,
 * }}
 */
export const usePagePropsContext = () => useContext(PagePropsContext);
